import { createSelector } from 'reselect'

export const getCurrentProfilePage = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.currentPage ? state.user.profile.currentPage : null,
  page => page
)
